import React from "react";
import { Button } from "antd";
import { useTranslation } from "react-i18next";

import "@/assets/toGIF.less";

const ToGIFWorkFooterRender = ({ preSubmit }) => {
  const { t } = useTranslation(["toGIF"]);
  return (
    <div className="footer">
      <Button className="save-btn" type="primary" size="large" onClick={()=>preSubmit(true)}>
        {t('Create GIF')}
      </Button>
    </div>
  );
};

export default ToGIFWorkFooterRender;
